export const isStringNullOrUndefinedOrWhiteSpace = (str) => {
    if (!str) {
        return true;
    }
    return isStringEmptyOrWhiteSpace(str);
};
export const isStringEmptyOrWhiteSpace = (str) => str === null || /^ *$/.exec(str) !== null;
